import type {ReactAction} from '@netx/core/bootstrap';
import {faBook} from '@netx/core-icons';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {cartActionCategorizeAdd} from './cart-categorize-add';
import {cartActionCategorizeMove} from './cart-categorize-move';
import {cartActionCategorizeRemove} from './cart-categorize-remove';

/**
 * Categorize cart assets
 * @param params
 * @returns Action
 */
export const cartActionCategorize = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-categorize',
	cb: () => {},
	icon: faBook,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CATEGORIZE;
	},
	children: [
		cartActionCategorizeAdd(),
		cartActionCategorizeMove(),
		cartActionCategorizeRemove(),
	],
	...params,
});

export default cartActionCategorize;
